<template>
  <vue-select :value="value" @search="getOptions"
    id="number" :options="items" class="select-x"
    placeholder="No Urut" @input="changed"/>
</template>

<script>
  import VueSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';

  export default {
    components: {
      VueSelect
    },
    data() {
      return {
        items: [],
      }
    },
    name: "NumberSelector",
    props: ["value", "min", "max", "data"],
    created() {
      this.init();
    },
    methods: {
      init() {
        for (let i = this.min; i <= this.max; i ++) {
          this.items.push({
            id: i,
            label: i,
          })
        }
      },
      getOptions(search, loading) {
        loading(true);
        this.init(search);
        loading(false);
      },
      changed(evt) {
        this.$emit('input', evt, this.data);
      }
    }
  }
</script>
